export const enum ServiceError {
  MISSING_REQUIRED_PARAMS = "Missing required query params",
}
